<template>
    <v-container color="primary">
        <v-row justify-md="center" wrap>
            <v-col cols="1" xs="0" sm="0" md="1">
            </v-col>
            <v-col cols="10" xs="12" sm="12" md="10">
                <materialfy-header-card cardTitle='BOTS' text="Here is a subtitle for this table" cardMinWidth="250"
                    :cardShowInnerList="false" :cardShowDivider="false">
                    <template v-slot:crdInner>
                        <br>
                        <v-divider class="mx-4" horizontal></v-divider>
                        <br>
                        <MaterialfyDataTables ref="dataTable" cardTitle="API" :showSearch="false" :actions="actions"
                            @action-clicked="handleActionClicked" :showCardTitle="false" />
                        <br>
                    </template>
                    <template #crdActions>
                        <br>
                        <v-divider class="mx-4" horizontal></v-divider>
                        <br>
                        <!-- <v-row no-gutters justify="center">
                            <v-btn @click="toHistoric">HISTORICO</v-btn>
                        </v-row> -->
                        <br>
                        <v-divider class="mx-4" horizontal></v-divider>
                        <br>
                    </template>
                </materialfy-header-card>
                <div class="w-auto" v-show="isOpenModalidad">
                    <MetodoPago ref="modalidad" @selection="receiveEmit" />
                </div>
                <div class="w-auto" v-show="isOpenModal">
                    <CriptoModal ref="modalCripto" />
                </div>
                <!-- <v-snackbar v-model="snackbar" :color="color" :bottom="bottom" :top="top" :float-left="left"
                    :float-right="right">
                    <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
                    <div>
                        {{ msg_toast }}
                    </div>
                    <v-icon size="16" @click="snackbar = false">
                        mdi-close-circle
                    </v-icon>
                </v-snackbar> -->
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import UserService from '@/services/user.service'
import MetodoPago from '@/components/dialogs/SelectModalidadComponent.vue'
import CriptoModal from '@/components/dialogs/CriptoModalComponent.vue'

export default {
    name: "MenusSuscripciones",
    components: {
        MetodoPago,
        CriptoModal,
        // AmazonModal,
        // TronPayment
    },
    data: () => ({
        title: 'Menu',
        headers: [
            { text: "Nombre", value: "nombre", align: "center" },
            { text: "Descripcion", value: "descripcion", align: "center" },
            { text: "Dias", value: "dias", align: "center" },
            { text: "Precio / $", value: "precio", align: "center" },
            { text: "Limite Bot", value: "limiteInversionPorBot", align: "center" },
            { text: 'Actions', value: 'actions', sortable: false, align: "center" }
        ],
        items: [],
        actions: [
            { icon: 'mdi-play', tooltip: 'Pagar', action: 'pay' },
            // { icon: 'mdi-content-save-edit-outline', tooltip: 'Modificar', action: 'update' },
            // { icon: 'mdi-trash-can-outline', tooltip: 'Eliminar', action: 'delete' }
        ],
        search: '',
        isOpenModal: false,
        isOpenModalidad: false,
    }),
    mounted() {
        UserService.getTypes().then(
            response => {
                // console.log(response.data)
                this.loadData(response.data);
            },
            error => {
                this.content =
                    (error.response && error.response.data && error.response.data.message) ||
                    error.message ||
                    error.toString();
                if (error.response && error.response.status === 403 || error.response.status === 401) {
                    this.$store
                        .dispatch('logout', this.user) //calls the login action and passes login info
                        .then(() => this.$router.push('/')) //redirect to dash after login
                        .catch((err) => {
                            console.log(err)
                            this.snackbar = true //shows error on wrong pass
                        })
                }
            }
        );
    },

    methods: {
        loadData(data) {
            this.items = data
            this.$refs.dataTable.headers = this.headers
            this.$refs.dataTable.items = this.items
        },
        handleActionClicked({ item, action }) {
            switch (action) {
                case 'pay':
                    console.log(item)
                    this.selected = item

                    // console.log(this.selected)
                    this.openMenuPay(item)
                    // console.log(URL_COINBASE.URL_COINBASE)
                    // console.log(value.productId)
                    // window.location.href = URL_COINBASE.URL_COINBASE + value.productId
                    // window.open(URL_COINBASE.URL_COINBASE + value.productId, '_blank');
                    // UserService.getLinkPay(this.$store.state.auth.user.email, value.id).then(
                    //     response => {
                    //         console.log(URL_COINBASE)
                    //         // console.log(response.paymentIntent)
                    //         // window.location.href = response.paymentIntent
                    //     },
                    //     error => {
                    //         this.content =
                    //             (error.response && error.response.data && error.response.data.message) ||
                    //             error.message ||
                    //             error.toString();
                    //         // EventBus.dispatch("logout");
                    //     }
                    // );
                    break;
            }
        },
        receiveEmit(value) {
            this.$refs.modalidad.closeModal()
            if (value === 'cripto') {
                this.openModalCripto()
            } else {
                this.openModalAmazon()
            }
        },
        openMenuPay(value) {
            this.item = value
            this.$refs.modalidad.openModal()
        },
        openModalCripto() {
            // console.log(this.selected)
            // this.$refs.modalTron.openModal()
            this.$router.push("/pay-cripto/?accion=" + this.accion + "&suscripcion=" + this.idSuscripcion + '&tipo=' + this.selected.id);
            // this.$refs.modalCripto.openModal(this.item)
            // this.$refs.modalCripto.item = this.item
            // this.$refs.modalCripto.idSuscripcion = this.selected.id
            // this.$refs.modalCripto.tituloSuscripcion = this.selected.nombre
            // this.$refs.modalCripto.dias = this.selected.dias
            // this.$refs.modalCripto.precio = this.selected.precio
            // this.$refs.modalCripto.total = this.selected.precio
        },
        openModalAmazon() {
            this.$refs.modal.openModal(this.item)
            this.$refs.modalCripto.item = this.item
            this.$refs.modal.idTipoSuscripcion = this.selected.id
            this.$refs.modal.tituloSuscripcion = this.selected.name
            this.$refs.modal.tipo = this.selected.nivel
            this.$refs.modal.bots = this.selected.bots
            this.$refs.modal.meses = this.selected.meses
            this.$refs.modal.precio = this.selected.precio
            this.$refs.modal.total = this.selected.precio
            setTimeout(() => this.$refs.modal.chargeButton(), 500);
        },
    },
};
</script>

<style></style>